var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-wallet-item"},[_c('ui-address',{attrs:{"address":_vm.address}}),_vm._v(" "),_c('div',{staticClass:"widget-wallet-data"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"widget-wallet-balance"},[_vm._v("\n            "+_vm._s(_vm.formattedBalance)+"\n        ")])],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('icon-gram',{staticClass:"widget-wallet-icon"})
}]

export { render, staticRenderFns }